import LogoPlatform from './logo-platform.svg';
export default LogoPlatform;

// function chooseLogo(): string {
//   // const env = getEnvironment();
//   return require('./logo-platform.svg') as string;
//   // if (env === 'development') {
//   //   return require('./logo-model-dev.svg') as string;
//   // } else if (env === 'staging') {
//   //   return require('./logo-model-staging.svg') as string;
//   // } else if (env === 'validation') {
//   //   return require('./logo-model-validation.svg') as string;
//   // } else {
//   //   return require('./logo-model.svg') as string;
//   // }
// }
